import React, { Component } from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import classNames from 'classnames';

import * as formulas from '../../services/formulas';

import './Results.scss';

class Results extends Component {
  get formResult() {
    return formulas.profitPerPayUser(this.props.formParams);
  }

  render() {
    const result = parseFloat(this.formResult, 10);
    const resLessZero = Number.isFinite(result) && result < 0;
    const { langs } = window;
    const classes = classNames({
      'results': true,
      'results_less-zero': resLessZero
    });
    const valuePrefixClass = classNames('results__value-prefix', {
      'results__value-prefix_en': langs.getLanguage() === 'en'
    });

    return (
      <div className={classes} ref={ref => this.ref = ref}>
        <div className="results__main-symbol"></div>
        <div className="results__inner">
          <div className="results__info">
            <div className="results__title">
              {
                resLessZero ?
                <React.Fragment>
                  { langs.lossMessage }
                </React.Fragment> :
                <React.Fragment>
                  { langs.profitMessage }
                </React.Fragment>
              }
              
            </div>
            <div className="results__value-holder">
              <div className="results__value-text">
                Profit Per Paying User
              </div>
              <div className="results__value">
                {
                  Number.isFinite(result) &&
                  <React.Fragment>
                    {result.toString().replace('.', ',')} <span className={ valuePrefixClass }> { langs.currencyText }.</span>
                  </React.Fragment>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const formParams = getFormValues('profit')(state) || {};
  const { language } = state;

  return {
    currentLang: language.current,
    formParams
  };
}

export default connect(mapStateToProps)(Results);


// WEBPACK FOOTER //
// ./src/components/Results/Results.js